import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || "Unknown UI error" };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught UI crash:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/dashboard";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 32, background: "#020617", color: "#fff", fontFamily: "system-ui, sans-serif" }}>
          <div style={{ maxWidth: 520, textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 16, opacity: 0.3 }}>!</div>
            <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Something went wrong</h1>
            <p style={{ fontSize: 14, color: "#94a3b8", lineHeight: 1.6, marginBottom: 8 }}>
              The system prevented a blank-screen failure. No financial data was changed by this UI error.
            </p>
            <pre style={{ fontSize: 12, color: "#ef4444", whiteSpace: "pre-wrap", background: "#0f172a", borderRadius: 8, padding: 12, marginBottom: 20, textAlign: "left", maxHeight: 120, overflow: "auto" }}>
              {this.state.errorMessage}
            </pre>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button onClick={this.handleReload} style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #22d3ee", background: "transparent", color: "#22d3ee", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>
                Reload Application
              </button>
              <button onClick={this.handleGoHome} style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #334155", background: "transparent", color: "#94a3b8", cursor: "pointer", fontSize: 13 }}>
                Return to Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
